var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aSection',{staticClass:"m-prices",attrs:{"title":_vm.section.title,"subtitle":_vm.section.subtitle}},[_c('oPrices')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }